import { AI, Eyebrow, Brands, today, RigHero, Reveal } from "./slideBits";
import IntroSlide from "./introSlide";
import AboutSlide from "./aboutSlide";
import SystemSlide from "./systemSlide";
import FeltSlide from "./feltSlide";

export { AI, Eyebrow, Placeholder } from "./slideBits";

/**
 * Slidene til presentasjonen for Stord Innkvartering (Kviteberg AS).
 * Én tanke per slide. Legg til flere objekter i SLIDES – motoren tar resten.
 */

/** Forside: riggen bygges modul for modul over tittelen. */
function CoverSlide() {
  return (
    <div className="pres-slide-inner flex flex-col" data-testid="pres-slide-forside">
      <Brands />
      <div className="pres-cover" data-testid="pres-cover">
        {/* Objektet først: riggen i full bredde, så én tittellinje og en meta-rad */}
        <RigHero className="pres-in" />
        <div className="pres-cover-text">
          <div className="pres-cover-meta">
            <Eyebrow className="pres-in" style={{ "--i": 0 }}>Presentasjon · {today()}</Eyebrow>
          </div>
          <h1 className="pres-h1 pres-cover-title" data-testid="pres-cover-title">
            <Reveal i={1}>Kva kan <span className="pres-accent-ki">{AI}</span> gjera for Stord Innkvartering?</Reveal>
          </h1>
        </div>
        <div className="pres-cover-foot pres-in" style={{ "--i": 7 }}>
          <div className="pres-presenter" data-testid="pres-presenter">
            <img src="/brand/martin-kviteberg.jpg" alt="Martin Kviteberg" className="pres-presenter-photo" draggable={false} />
            <div>
              <div className="pres-presenter-name">Martin Kviteberg</div>
              <div className="pres-presenter-org">Kviteberg AS</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const SLIDES = [
  { id: "intro", title: "Start", intro: true, render: () => <IntroSlide /> },
  { id: "forside", title: "Forside", render: () => <CoverSlide /> },
  { id: "om-meg", title: "Om meg", render: () => <AboutSlide /> },
  { id: "system", title: "Eitt sentralt driftssystem", render: () => <SystemSlide /> },
  { id: "felt", title: "Feltvisning", render: () => <FeltSlide /> },
];
